<template>
	<div class="aside" :class="{ collapse: isCollapse }">
		<div class="sider-logo">
			<router-link to="/">
				<!-- <img src="@/assets/logo.png" alt="logo" /> -->
				<h1 v-if="!isCollapse">{{ systemInfo.title }}</h1>
			</router-link>
		</div>
		<el-scrollbar wrap-class="scrollbar-wrapper">
			<el-menu class="el-menu-vertical" unique-opened :collapse="isCollapse" :default-active="activeMenu">
				<MenuItem v-for="(route, index) in menulist" :key="index" :item="route"> </MenuItem>
			</el-menu>
		</el-scrollbar>
		<div class="sider-links" @click="setCollapse(!isCollapse)">
			<i
				:class="{
					'el-icon-right': isCollapse,
					'el-icon-back': !isCollapse
				}"
			></i>
		</div>
	</div>
</template>

<script>
	import MenuItem from './MenuItem';
	import { debounce } from 'throttle-debounce';

	// 自适应侧边栏断点，修改时还需要修改对应的css
	const minWidth = 1200;

	export default {
		components: {
			MenuItem
		},
		data() {
			return {
				resizeEnet: debounce(150, false, () => {
					let screenWidth = document.body.clientWidth;
					if (this.$store.state.facility.screenWidth >= minWidth && screenWidth < minWidth) {
						// 从大屏切换到小屏
						this.$store.commit('setCollapse', true);
					} else if (this.$store.state.facility.screenWidth < minWidth && screenWidth >= minWidth) {
						// 从小屏切换到大屏
						this.$store.commit('setCollapse', false);
					}
					this.$store.commit('setScreenWidth', document.body.clientWidth);
				})
			};
		},
		computed: {
			//控制侧边栏展开收起状态
			isCollapse() {
				return this.$store.state.layout.isCollapse;
			},
			//获取后端路由表
			menulist() {
				// 路由处理
				let info = JSON.parse(sessionStorage.getItem('admin-info'));
				let role = info.group_id == 99 ? 1 : info.group_id == 2 ? 2 : 3; // 3- 客服 2-代理 1-管理员

				// 管理员权限
				let ManageRouter = ['Welcome', 'Home', 'KfAdminUList', 'DomainList', 'IPList', 'BlackIPList', 'AgreeCountry', 'UpdateToken'];
				// 代理
				let AgentRouter = ['Home', 'KfAdminUList', 'DomainList', 'IPList', 'BlackIPList', 'AgreeCountry'];
				// 客服权限
				let CustomRouter = ['Welcome'];
				// 其他
				let LineRouter = [];

				let limit = role == 1 ? ManageRouter : role == 2 ? AgentRouter : role == 3 ? CustomRouter : LineRouter;
				let list = JSON.parse(JSON.stringify(this.$store.state.layout.menuList));
				let menu = list.filter((item) => {
					if (item.children) {
						let newChildren = item.children.filter((val) => {
							return limit.includes(val.name);
						});
						if (newChildren.length > 0) {
							item.children = newChildren;
							return true;
						}
					} else {
						return limit.includes(item.name);
					}
				});
				return menu;
				// return this.$store.state.layout.menuList;
			},
			activeMenu() {
				const route = this.$route;
				const { meta, path } = route;
				if (meta.activeMenu) {
					return meta.activeMenu;
				}
				return path;
			},
			systemInfo() {
				if (sessionStorage.getItem('common-config')) {
					return JSON.parse(sessionStorage.getItem('common-config'));
				} else {
					return {
						systemInfo: { title: 'Line 短链' }
					};
				}
			}
		},
		mounted() {
			if (this.$store.state.facility.screenWidth < minWidth) {
				// 小屏状态下默认收起
				this.$store.commit('setCollapse', true);
			}

			window.addEventListener('resize', this.resizeEnet);
		},
		methods: {
			// 控制侧边栏导航
			setCollapse(collapse) {
				this.$store.commit('setCollapse', collapse);
			}
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.resizeEnet);
		}
	};
</script>

<style scoped lang="scss">
	.aside {
		width: 190px;
		display: flex;
		flex-direction: column;
		height: 100vh;
		background-color: $menu-bg;
		transition: width 0.5s;
	}

	.collapse {
		width: 64px;
	}

	// 小屏下的样式
	@media screen and (max-width: 1200px) {
		.aside {
			position: absolute;
			left: 0;
			z-index: 2000;
		}

		.collapse {
			width: 0px;
		}
	}

	.aside ::v-deep .el-menu {
		border-right: none;
		background-color: $menu-bg;
	}

	.el-menu-vertical:not(.el-menu--collapse) {
		width: 190px;
	}

	.aside ::v-deep .el-scrollbar {
		flex: 1 1 0%;
		overflow: hidden auto;
	}

	.aside ::v-deep .scrollbar-wrapper {
		overflow-x: hidden !important;
	}

	.aside ::v-deep .el-menu-item,
	.aside ::v-deep .el-submenu__title {
		color: $menu-font-color;
	}

	.aside ::v-deep .el-menu-item:hover,
	.aside ::v-deep .el-menu-item:focus,
	.aside ::v-deep .el-submenu__title:hover,
	.aside ::v-deep .el-submenu__title:focus {
		background-color: $menu-item-hover;
	}

	.aside ::v-deep .el-menu-item.is-active {
		color: $emnu-item-active-coloe;
		background: $emnu-item-active-background;
	}

	/* 底部箭头按钮样式 */
	.sider-links {
		text-align: center;
		height: 48px;
		border-top: 1px solid #f0f0f0;
		font-size: 24px;
		color: #fff;
		cursor: pointer;
	}

	.sider-links:hover {
		color: $emnu-item-active-coloe;
	}

	.sider-links i {
		display: inline-block;
		width: 64px;
		line-height: 48px;
		text-align: center;
	}

	/* logo样式 */
	.sider-logo {
		height: 60px;
		display: flex;
		align-items: center;
		overflow: hidden;
		line-height: 32px;
		cursor: pointer;
		transition: padding 0.2s;
		background: $menu-logo-bg;
	}

	.sider-logo a {
		margin-left: 16px;
		display: flex;
	}

	.sider-logo img {
		display: block;
		height: 32px;
		transition: height 0.2s;
	}

	.sider-logo h1 {
		display: block;
		height: 32px;
		margin: 0 0 0 12px;
		color: $menu-font-color;
		font-weight: 600;
		font-size: 18px;
		line-height: 32px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
</style>
